

























// vue
import { defineComponent, ref } from '@vue/composition-api';

// components
import Tools from '@/vue3/components/geo-record-tools';
import Surface from '@/vue3/components/Surface.vue';

export default defineComponent({
    components: {
        ...Tools,
        Surface,
    },
    props: {
        mapbox: {
            type: Object,
            default: null,
        },
        setMapboxDrawSnap: {
            type: Function,
            default: () => {},            
        },
        setMapboxElevation: {
            type: Function,
            default: () => {},            
        },
        updateUtilityDrawerState: {
            type: Function,
            default: () => {},            
        },
        utilityDrawer: {
            type: Object,
            default: null,
        },
        isGpsActive: {
            type: Boolean,
            default: false,
        },
        activeCreateToolName: {
            type: String,
            default: '',
        },
        setActiveCreateToolName: {
            type: Function,
            default: () => {},
        },
        layerTree: {
            type: Object,
            default: null,
        },
        value: {
            type: Object,
            default: null,
        },
    },
    setup() {
        // properties
        const toolMapping = {
            ...Tools,
        };

        // ref
        const CreateTool = ref(null);

        return {
            toolMapping,
            CreateTool,
        };
    },
});
